import axios from "axios";

import miniToastr from "mini-toastr";
import {HelperToService} from "@/apiServices/HelperToService";
import _ from "lodash";
import Swal from "sweetalert2";

export class Service extends HelperToService {

    constructor(endpoint) {
        super();
        this._ = _;
        this.data = [];
        this.fieldPrimaryKey = '';
        this.nombreSingular = 'Tipo dentacion';
        this.nombrePlural = 'Tipos de dentacion';
        this.fields = [];
        this.mostrarAcciones = true;
        this.botones = {
            mostrarBorrar: false,
            mostrarVer: false,
            mostrarActualizar: false,
            mostrarCrear: false,
        }
        this.hardDelete = false;
        this.perPage = 15;
        this.currentPage = 1;
        this.filter = null;
        this.filterOn = []
        this.loading = false;
        this.endpoint = endpoint;
        this.http = axios;
        this.toast = miniToastr;
    }

    onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    }

    getUrl(pathParam, queryParams) {

        let url = process.env.VUE_APP_BACK_API_BASE_URL + this.endpoint;
        if (pathParam) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }

        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }
    getUrlBase(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_BASE_URL + '/' + this.endpoint;
        if (pathParam) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }
        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }

    onError(error) {
        // this.toast.error(error.response.data.message)
        throw  new Error(error.message)
    }

    swalError(error){
        Swal.fire({
            icon: "error",
            text: error.response.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
        });
    }

    swalWarning(error){
        Swal.fire({
            icon: "warning",
            text: error.response.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
        });
    }

    swalSuccess(text){
        Swal.fire({
            icon: "success",
            text: text,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
        });
    }


    onData(response) {
        return this.mapToClass(response.data)
    }

    mapToClass(data) {
        return data;
    }

    onStart() {
        this.loading = true;
    }

    onFinaly() {
        this.loading = false;
    }

    orderData(campo, order) {
        return this._.orderBy(this.data, [campo],[order])
    }
    orderAscData(campo) {
        return this.orderData(campo, 'asc')
    }
    orderDescData(campo) {
        return this.orderData(campo, 'desc')
    }

    listar(params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['listar'], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    encontrarUno(id, params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', id], params), config)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    crear(object, params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar'], params), object, config)
            .then((response) => {
                this.toast.info("Datos guardados con exito")
                return this.onData(response)
            })
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    actualizar(object, params, config) {
        this.onStart();
        return this.http.put(this.getUrl(['actualizar', object[this.fieldPrimaryKey]]), object, config)
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    eliminar(object, params, config) {
        this.onStart();
        return this.http.delete(this.getUrl(['eliminar', object[this.fieldPrimaryKey]]), config)
            .then((response) => this.onData(response))
            .catch(() => {
                object.registroActivo = false; // si no se puede eliminar se manda un softdelete
                return this.actualizar(object)
                    .then((response) => this.onData(response))
                    .catch(this.onError)
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
